import { generateBaseQueryKeysList } from '@/queries/utils';

export const DRIVE_SERVICE_TRIPS_KEYS = {
  main: 'drive-service-trips',
};

export const driveServiceTripsQueryKeys = generateBaseQueryKeysList(DRIVE_SERVICE_TRIPS_KEYS.main);
